import { pane } from '../../../../APP/page/pane/PANE.js';
import PANELOADER from '../../../../APP/page/paneloader/PANELOADER.js';
import PANE_Blog_Articles from '../../../../APP/page/paneloader/paneloaders/PANELOADER_BLOG/PANE_Blog_Articles.js';
export default class PANELOADER_BLOG extends PANELOADER {
    constructor(page, model) {
        super(page, model);
    }
    paneSwitch(name) {
        switch (name) {
            case 'articles': {
                this.page.horizontal.center.addChild(new PANE_Blog_Articles(this.page.horizontal.center, pane()));
                break;
            }
            default:
                console.log('Unable to load PANE::' + name);
        }
    }
}
